import React from "react";

const LockCloseIcon = ({
  style = {},
  width = "70",
  height = "70",
  className = "",
  fill = "#7758B3",
  stroke = "#7758B3",
  viewBox = "0 0 70 70",
}) => (
<svg style={{width:"12px",height:"15px"}}  version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 14 15" fill="none">
  <path fill="#5D737E" class="st0" d="M6.8,8.7C6,8.7,5.2,9.3,5.2,10c0,0.7,0.7,1.3,1.6,1.3s1.6-0.6,1.6-1.3C8.4,9.3,7.7,8.7,6.8,8.7z M11.6,5.3h-0.8  V4c0-1.8-1.8-3.3-4-3.3C5,0.7,3.4,1.7,3,3.2C2.9,3.6,3.1,3.9,3.5,4c0.1,0,0.2,0,0.3,0C4,4,4.1,4,4.1,3.9c0.1,0,0.2-0.1,0.2-0.2  c0.1-0.1,0.1-0.2,0.1-0.2C4.7,3.1,5,2.7,5.4,2.4C5.8,2.1,6.3,2,6.8,2c1.3,0,2.4,0.9,2.4,2v1.3H2c-0.9,0-1.6,0.6-1.6,1.3v6.7  c0,0.7,0.7,1.3,1.6,1.3h9.6c0.9,0,1.6-0.6,1.6-1.3V6.7C13.2,5.9,12.5,5.3,11.6,5.3z M11.6,12.7c0,0.4-0.4,0.7-0.8,0.7h-8  C2.4,13.3,2,13,2,12.7V7.3C2,7,2.4,6.7,2.8,6.7h8c0.4,0,0.8,0.3,0.8,0.7V12.7z"/>
  <rect x="2.9" y="3.4" fill="#5D737E" width="1.6" height="1.9"/>
  <rect x="9.4" y="3.9" transform="matrix(3.962645e-03 -1 1 3.962645e-03 5.3366 14.6944)" fill="#5D737E" width="1.3" height="1.6"/>
</svg>
);

export default LockCloseIcon;
